import React, { useEffect } from "react";
import { useStoreActions, useStoreState } from 'easy-peasy';
import { useParams } from "react-router-dom";
import Loader from "../../components/widgets/Loader";
import ActivityDetailsComponent from "../../components/activity/ActivityDetailsComponent";

const ActivityDetailPage = () => {
    const { uniqueId } = useParams();

    const { activityById, isFetchingOneActivity } = useStoreState(state => state.activity);
    const { fetchActivityById } = useStoreActions(actions => actions.activity);

    const activitySlugs = useStoreState(actions => actions.actionSlugs.actionSlugsDispatcher('activity'));

    useEffect(() => {
        fetchActivityById(uniqueId);
    }, []);


    const returnLink = activitySlugs.readAll;

    return (!activityById || isFetchingOneActivity)
        ? <Loader />
        : <ActivityDetailsComponent
            activity={activityById}
            returnLink={returnLink}
        />
}

export default ActivityDetailPage;